const shop = {
	sidebar: [
		{
			code: 'ss1',
			label: 'Shop Left Sidebar',
		},
		{
			code: 'ss2',
			label: 'Shop Right Sidebar',
		},

		{
			code: 'ss3',
			label: 'Shop No Sidebar',
		},
		{
			code: '',
			label: 'No one',
		},
	],
	filter: [
		{
			code: 'sf1',
			label: 'Shop Canvas Filter',
		},
		{
			code: 'sf2',
			label: 'Shop Category Filter',
		},
		{
			code: 'sf3',
			label: 'Shop Filter Hide',
		},
		{
			code: 'sf4',
			label: 'Shop Top Filter',
		},
		{
			code: '',
			label: 'No one',
		},
	],
	category: [
		{
			code: 'sc1',
			label: 'Shop With Category',
		},
		{
			code: '',
			label: 'No one',
		},
	],
};

const product = {
	view: [
		{
			code: 'pv1',
			label: 'List',
		},
		{
			code: 'pv2',
			label: 'Grid 2 column',
		},
		{
			code: 'pv3',
			label: 'Grid 3 column',
		},
		{
			code: 'pv4',
			label: 'Grid 4 column',
		},
		{
			code: '',
			label: 'No one',
		},
	],
	detail: [
		{
			code: 'pd1',
			label: 'Product 4 images',
		},
		{
			code: 'pd2',
			label: 'Product Left Sidebar',
		},
		{
			code: 'pd3',
			label: 'Product Left thumbnail',
		},
		{
			code: 'pd4',
			label: 'Product No Sidebar',
		},
		{
			code: 'pd5',
			label: 'Product Right Sidebar',
		},
		{
			code: 'pd6',
			label: 'Product Right thumbnail',
		},
		{
			code: 'pd7',
			label: 'Product Sticky',
		},
		{
			code: '',
			label: 'No one',
		},
	],
	variant: [
		{
			code: false,
			label: 'product shown as a single variant',
		},
		{
			code: true,
			label: 'product shown with all variants displayed',
		},
	],
};
// ordine consigliato (proposta di design della home): slider, categorie, offerte (bundle, a tempo, combo),
// più venduti, consigliati, ultimi pezzi e prezzi in calo, nuovi arrivi, nuove offerte, più visti, brand,
// confronto, visti di recente, scheda punti, recensioni; in fondo il testo CMS (SEO)
const homepage = [
	{
		code: 'h1',
		label: 'Slider',
		active: false,
	},
	{
		code: 'h3',
		label: 'Top Category',
		active: false,
	},
	{
		code: 'h18',
		label: 'Bundle offers',
		active: true,
	},
	{
		code: 'h12',
		label: 'Timed offers',
		active: false,
	},
	{
		code: 'h15',
		label: 'Combo',
		active: false,
	},
	{
		code: 'h4',
		label: 'Best sellers',
		active: false,
	},
	{
		code: 'h5',
		label: 'Recommended for you',
		active: false,
	},
	{
		code: 'h13',
		label: 'Low stock',
		active: false,
	},
	{
		code: 'h14',
		label: 'Price drops',
		active: false,
	},
	{
		code: 'h7',
		label: 'New Arrival',
		active: false,
	},
	{
		code: 'h6',
		label: 'New Offers',
		active: false,
	},
	{
		code: 'h8',
		label: 'Most popular',
		active: false,
	},
	{
		code: 'h2',
		label: 'Top Brand',
		active: false,
	},
	{
		code: 'h17',
		label: 'Compare in progress',
		active: false,
	},
	{
		code: 'h9',
		label: 'Pick up where you left off',
		active: false,
	},
	{
		code: 'h16',
		label: 'Loyalty card',
		active: false,
	},
	{
		code: 'h11',
		label: 'Reviews',
		active: false,
	},
	{
		code: 'h10',
		label: 'Homepage Text CMS',
		active: false,
	},
];

module.exports = {
	shop,
	product,
	homepage,
};
